<script module>
  export const meta = {
    title: 'Recommendations',
    teaser:
      'This help page outlines recommendations for making the most of Pausly,\nemphasizing regular movement, the use of its social features for motivation, and\nintroducing it in the workplace.',
    sort: 8,
  }
</script>

<p>
  To maximize the benefits of Pausly, here are our key recommendations and best
  practices.
</p>
<p>
  Numerous studies have highlighted the health risks associated with prolonged
  periods of sitting or inactivity. It is advised to get moving at least once
  every hour to combat this.
</p>
<p>
  We understand this might be challenging. The goal is to move as frequently as
  suits <em>you</em>. Even if that equates to just once or twice a day, it's a
  significant step forward!
</p>
<p>
  Remember, Pausly isn't just for workdays. If you find yourself immersed in a
  gaming marathon during your days off, Pausly can be an excellent way to
  incorporate some physical activity.
</p>
<p>
  While Pausly offers great benefits when used individually, you'll find its
  true potential through its social features. Encourage your friends to join and
  keep each other inspired. It's easy to overlook a timer telling you to take a
  break, but an invite from a friend packs a stronger motivational punch.
</p>
<p>
  If you're finding Pausly beneficial, consider introducing it at your
  workplace. Chat with your manager or HR department about how Pausly could
  support a healthier, more dynamic work environment.
</p>
